import { useState } from 'react'

const _logoDevFailed = new Set()
const _googleFailed  = new Set()

const DOMAIN_MAP = [
  // ── Streaming & Entertainment ────────────────────────────
  ['netflix',          'netflix.com'],
  ['spotify',          'spotify.com'],
  ['amazon prime',     'amazon.co.uk'],
  ['prime video',      'amazon.co.uk'],
  ['disney',           'disneyplus.com'],
  ['apple tv',         'apple.com'],
  ['apple music',      'apple.com'],
  ['icloud',           'apple.com'],
  ['now tv',           'nowtv.com'],
  ['now ',             'nowtv.com'],
  ['paramount',        'paramountplus.com'],
  ['crunchyroll',      'crunchyroll.com'],
  ['mubi',             'mubi.com'],
  ['plex',             'plex.tv'],
  ['dazn',             'dazn.com'],
  ['discovery',        'discoveryplus.com'],
  ['bbc iplayer',      'bbc.co.uk'],
  ['britbox',          'britbox.com'],
  ['hayu',             'hayu.com'],
  ['shudder',          'shudder.com'],
  ['headspace',        'headspace.com'],
  ['calm',             'calm.com'],
  ['audible',          'audible.co.uk'],
  ['blinkist',         'blinkist.com'],
  ['duolingo',         'duolingo.com'],
  ['babbel',           'babbel.com'],
  ['youtube premium',  'youtube.com'],
  ['youtube',          'youtube.com'],

  // ── Gaming ───────────────────────────────────────────────
  ['playstation',      'playstation.com'],
  ['xbox',             'xbox.com'],
  ['nintendo',         'nintendo.com'],
  ['ea ',              'ea.com'],
  ['ubisoft',          'ubisoft.com'],
  ['epic games',       'epicgames.com'],
  ['steam',            'store.steampowered.com'],
  ['humble',           'humblebundle.com'],

  // ── UK Telecoms ──────────────────────────────────────────
  ['sky ',             'sky.com'],
  ['bt ',              'bt.com'],
  ['virgin media',     'virginmedia.com'],
  ['virgin ',          'virginmedia.com'],
  ['vodafone',         'vodafone.co.uk'],
  ['o2 ',              'o2.co.uk'],
  ['three',            'three.co.uk'],
  ['ee ',              'ee.co.uk'],
  ['giffgaff',         'giffgaff.com'],
  ['smarty',           'smarty.co.uk'],
  ['voxi',             'voxi.co.uk'],
  ['talktalk',         'talktalk.co.uk'],
  ['plusnet',          'plus.net'],
  ['tesco mobile',     'tescomobile.com'],
  ['sky mobile',       'sky.com'],
  ['id mobile',        'idmobile.co.uk'],
  ['hyperoptic',       'hyperoptic.com'],
  ['zen internet',     'zen.co.uk'],
  ['talkmobile',       'talkmobile.co.uk'],

  // ── UK Energy ────────────────────────────────────────────
  ['octopus',          'octopusenergy.com'],
  ['british gas',      'britishgas.co.uk'],
  ['e.on',             'eon.com'],
  ['eon ',             'eon.com'],
  ['edf',              'edfenergy.com'],
  ['scottish power',   'scottishpower.co.uk'],
  ['ovo ',             'ovoenergy.com'],
  ['bulb',             'bulb.co.uk'],
  ['shell energy',     'shellenergy.co.uk'],
  ['utility warehouse','utilitywarehouse.co.uk'],
  ['utilita',          'utilita.co.uk'],
  ['good energy',      'goodenergy.co.uk'],
  ['ecotricity',       'ecotricity.co.uk'],
  ['so energy',        'so.energy'],

  // ── UK Water ─────────────────────────────────────────────
  ['anglian water',    'anglianwater.co.uk'],
  ['anglian ',         'anglianwater.co.uk'],
  ['thames water',     'thameswater.co.uk'],
  ['thames ',          'thameswater.co.uk'],
  ['severn trent',     'severntrent.com'],
  ['yorkshire water',  'yorkshirewater.com'],
  ['wessex water',     'wessexwater.co.uk'],
  ['south west water', 'southwestwater.co.uk'],
  ['united utilities', 'unitedutilities.com'],
  ['northumbrian',     'nwl.co.uk'],
  ['southern water',   'southernwater.co.uk'],
  ['affinity water',   'affinitywater.co.uk'],
  ['bristol water',    'bristolwater.co.uk'],
  ['south east water', 'southeastwater.co.uk'],
  ['dwr cymru',        'dwrcymru.com'],
  ['welsh water',      'dwrcymru.com'],
  ['scottish water',   'scottishwater.co.uk'],
  ['portsmouth water', 'portsmouthwater.co.uk'],

  // ── UK Banks & Building Societies ────────────────────────
  ['barclays',         'barclays.co.uk'],
  ['hsbc',             'hsbc.co.uk'],
  ['lloyds',           'lloydsbank.com'],
  ['nationwide',       'nationwide.co.uk'],
  ['natwest',          'natwest.com'],
  ['santander',        'santander.co.uk'],
  ['halifax',          'halifax.co.uk'],
  ['monzo',            'monzo.com'],
  ['revolut',          'revolut.com'],
  ['starling',         'starlingbank.com'],
  ['virgin money',     'virginmoney.com'],
  ['yorkshire bank',   'ybs.co.uk'],
  ['ybs',              'ybs.co.uk'],
  ['coventry building','coventrybuildingsociety.co.uk'],
  ['skipton',          'skipton.co.uk'],
  ['principality',     'principality.co.uk'],
  ['metro bank',       'metrobank.co.uk'],
  ['tsb',              'tsb.co.uk'],
  ['first direct',     'firstdirect.com'],
  ['clydesdale',       'cbonline.co.uk'],
  ['tesco bank',       'tescobank.com'],
  ['aldermore',        'aldermore.co.uk'],
  ['atom bank',        'atombank.co.uk'],
  ['chase',            'chase.co.uk'],

  // ── Investment & Finance ─────────────────────────────────
  ['vanguard',         'vanguard.co.uk'],
  ['hargreaves lansdown','hl.co.uk'],
  ['hl ',              'hl.co.uk'],
  ['aj bell',          'ajbell.co.uk'],
  ['interactive investor','ii.co.uk'],
  ['freetrade',        'freetrade.io'],
  ['trading 212',      'trading212.com'],
  ['nutmeg',           'nutmeg.com'],
  ['wealthify',        'wealthify.com'],
  ['moneyfarm',        'moneyfarm.com'],
  ['chip ',            'chipsaving.com'],
  ['plum ',            'withplum.com'],
  ['moneybox',         'moneyboxapp.com'],
  ['paypal',           'paypal.com'],

  // ── Insurance ────────────────────────────────────────────
  ['aviva',            'aviva.co.uk'],
  ['axa',              'axa.co.uk'],
  ['bupa',             'bupa.co.uk'],
  ['vitality',         'vitality.co.uk'],
  ['direct line',      'directline.com'],
  ['admiral',          'admiral.com'],
  ['churchill',        'churchill.com'],
  ['hastings',         'hastingsdirect.com'],
  ['lv=',              'lv.com'],
  ['lv ',              'lv.com'],
  ['legal & general',  'legalandgeneral.com'],
  ['legal and general','legalandgeneral.com'],
  ['prudential',       'prudential.co.uk'],
  ['nfu mutual',       'nfumutual.co.uk'],
  ['more than',        'morethan.com'],
  ['esure',            'esure.com'],
  ['pet plan',         'petplan.co.uk'],
  ['petplan',          'petplan.co.uk'],
  ['bought by many',   'boughtbymany.com'],
  ['medicash',         'medicash.org'],
  ['simply health',    'simplyhealth.co.uk'],
  ['health shield',    'healthshield.co.uk'],
  ['sun life',         'sunlife.co.uk'],
  ['zurich',           'zurich.co.uk'],

  // ── Mortgages (main lenders already in banks) ────────────
  ['nationwide mortgage','nationwide.co.uk'],
  ['halifax mortgage',   'halifax.co.uk'],

  // ── Gyms & Fitness ───────────────────────────────────────
  ['pure gym',         'puregym.com'],
  ['the gym',          'thegymgroup.com'],
  ['david lloyd',      'davidlloyd.co.uk'],
  ['bannatyne',        'bannatyne.co.uk'],
  ['nuffield',         'nuffieldhealth.com'],
  ['anytime fitness',  'anytimefitness.co.uk'],
  ['gymbox',           'gymbox.com'],
  ['barry\'s',         'barrys.com'],
  ['f45',              'f45training.com'],
  ['peloton',          'onepeloton.co.uk'],
  ['fitbit',           'fitbit.com'],
  ['strava',           'strava.com'],
  ['myfitnesspal',     'myfitnesspal.com'],

  // ── Supermarkets ─────────────────────────────────────────
  ['tesco',            'tesco.com'],
  ['sainsbury',        'sainsburys.co.uk'],
  ['waitrose',         'waitrose.com'],
  ['asda',             'asda.com'],
  ['morrisons',        'morrisons.com'],
  ['ocado',            'ocado.com'],
  ['aldi',             'aldi.co.uk'],
  ['lidl',             'lidl.co.uk'],
  ['marks & spencer',  'marksandspencer.com'],
  ['marks and spencer','marksandspencer.com'],
  ['m&s',              'marksandspencer.com'],
  ['co-op',            'coop.co.uk'],

  // ── Food delivery & subscriptions ────────────────────────
  ['deliveroo',        'deliveroo.co.uk'],
  ['just eat',         'just-eat.co.uk'],
  ['uber eats',        'ubereats.com'],
  ['hellofresh',       'hellofresh.co.uk'],
  ['gousto',           'gousto.co.uk'],
  ['mindful chef',     'mindfulchef.com'],
  ['abel & cole',      'abelandcole.co.uk'],
  ['oddbox',           'oddbox.co.uk'],

  // ── Transport ────────────────────────────────────────────
  ['uber',             'uber.com'],
  ['trainline',        'thetrainline.com'],
  ['national rail',    'nationalrail.co.uk'],
  ['tfl',              'tfl.gov.uk'],
  ['transport for london','tfl.gov.uk'],
  ['zipcar',           'zipcar.co.uk'],
  ['enterprise',       'enterprise.co.uk'],
  ['hertz',            'hertz.co.uk'],
  ['aa ',              'theaa.com'],
  ['rac ',             'rac.co.uk'],
  ['green flag',       'greenflag.com'],
  ['airbnb',           'airbnb.com'],
  ['booking.com',      'booking.com'],
  ['expedia',          'expedia.co.uk'],

  // ── Tech / Apple / Google ────────────────────────────────
  ['apple',            'apple.com'],
  ['google',           'google.com'],
  ['google one',       'google.com'],
  ['microsoft',        'microsoft.com'],
  ['microsoft 365',    'microsoft.com'],
  ['office 365',       'microsoft.com'],
  ['adobe',            'adobe.com'],
  ['dropbox',          'dropbox.com'],
  ['notion',           'notion.so'],
  ['slack',            'slack.com'],
  ['zoom',             'zoom.us'],
  ['github',           'github.com'],
  ['openai',           'openai.com'],
  ['chatgpt',          'openai.com'],
  ['linkedin',         'linkedin.com'],
  ['canva',            'canva.com'],
  ['figma',            'figma.com'],
  ['1password',        '1password.com'],
  ['nordvpn',          'nordvpn.com'],
  ['expressvpn',       'expressvpn.com'],
  ['grammarly',        'grammarly.com'],
  ['evernote',         'evernote.com'],
  ['asana',            'asana.com'],
  ['monday.com',       'monday.com'],
  ['todoist',          'todoist.com'],
  ['trello',           'trello.com'],
  ['bitwarden',        'bitwarden.com'],
  ['dashlane',         'dashlane.com'],
  ['lastpass',         'lastpass.com'],
  ['backblaze',        'backblaze.com'],
  ['squarespace',      'squarespace.com'],
  ['wix',              'wix.com'],
  ['shopify',          'shopify.com'],
  ['quickbooks',       'quickbooks.com'],
  ['xero',             'xero.com'],
  ['mailchimp',        'mailchimp.com'],

  // ── Charity / Regular giving ─────────────────────────────
  ['macmillan',        'macmillan.org.uk'],
  ['cancer research',  'cancerresearchuk.org'],
  ['british heart',    'bhf.org.uk'],
  ['rnli',             'rnli.org'],
  ['wwf',              'wwf.org.uk'],
  ['oxfam',            'oxfam.org.uk'],
  ['rspca',            'rspca.org.uk'],
  ['red cross',        'redcross.org.uk'],
  ['save the children','savethechildren.org.uk'],
  ['unicef',           'unicef.org.uk'],
  ['shelter',          'shelter.org.uk'],
  ['mind ',            'mind.org.uk'],

  // ── Government / Licences ────────────────────────────────
  ['tv licence',       'tvlicensing.co.uk'],
  ['tv license',       'tvlicensing.co.uk'],
  ['dvla',             'dvla.gov.uk'],
  ['hmrc',             'hmrc.gov.uk'],
  ['student loans',    'slc.co.uk'],
  ['student loan',     'slc.co.uk'],

  // ── Retail subscriptions ─────────────────────────────────
  ['amazon',           'amazon.co.uk'],
  ['next ',            'next.co.uk'],
  ['asos',             'asos.com'],
  ['john lewis',       'johnlewis.com'],
  ['argos',            'argos.co.uk'],
  ['currys',           'currys.co.uk'],
  ['very ',            'very.co.uk'],
  ['littlewoods',      'littlewoods.com'],
  ['klarna',           'klarna.com'],
  ['clearpay',         'clearpay.co.uk'],
  ['laybuy',           'laybuy.com'],

  // ── Optical ──────────────────────────────────────────────
  ['specsavers',       'specsavers.co.uk'],
  ['vision express',   'visionexpress.com'],
  ['boots opticians',  'boots.com'],

  // ── Personal care / grooming ─────────────────────────────
  ['harrys',           'harrys.com'],
  ['harry\'s',         'harrys.com'],
  ['manscaped',        'manscaped.com'],
  ['gillette',         'gillette.co.uk'],

  // ── Broadband / TV extras ────────────────────────────────
  ['seethelight',      'seethelight.co.uk'],
  ['iwnl',             'iwnl.co.uk'],
  ['leeds building',   'leedsbuildingsociety.co.uk'],
  ['sage homes',       'sagehomes.co.uk'],
]

export function getBillDomain(name) {
  if (!name) return null
  const lower = name.toLowerCase()
  const match = DOMAIN_MAP.find(([key]) => lower.includes(key))
  return match ? match[1] : null
}

export const CAT_ICON = cat => ({
  Housing: '🏠', Transport: '🚗', Subscriptions: '📱',
  Utilities: '⚡', Insurance: '🛡️', Groceries: '🛒',
  'Eating Out': '🍽️', Health: '💊', Entertainment: '🎮',
  Savings: '🏦', Investments: '📈', Clothing: '👗',
  'Personal Care': '🪥', Baby: '🍼', Pet: '🐾',
  Business: '💼', Loan: '🏦', Bills: '🧾', Other: '🧾',
}[cat] || '🧾')

export default function BillLogo({ name, category, size = 42, radius = 12, showCR = false }) {
  const [tick, setTick] = useState(0) // eslint-disable-line no-unused-vars
  const domain = getBillDomain(name)
  const bg = 'rgba(255,255,255,0.08)'
  const imgSize = Math.round(size * 0.72)

  const crBadge = showCR ? (
    <div style={{ position: 'absolute', bottom: -3, right: -3, background: '#e05252', borderRadius: '3px', fontSize: '8px', fontWeight: 800, color: '#fff', padding: '1px 3px', fontFamily: 'Manrope, sans-serif', letterSpacing: '0.04em', lineHeight: 1.2, zIndex: 2 }}>CR</div>
  ) : null

  if (!domain) {
    return (
      <div style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
        <div style={{ width: size, height: size, borderRadius: radius, background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: Math.round(size * 0.52) }}>
          {CAT_ICON(category)}
        </div>
        {crBadge}
      </div>
    )
  }

  if (!_logoDevFailed.has(domain)) {
    return (
      <div style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
        <div style={{ width: size, height: size, borderRadius: radius, background: bg, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img src={`https://img.logo.dev/${domain}?token=pk_XO4Ke3-cTjuxoWHtDdLnzQ&size=80&format=png`} alt={name} onError={() => { _logoDevFailed.add(domain); setTick(t => t + 1) }} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        </div>
        {crBadge}
      </div>
    )
  }

  if (!_googleFailed.has(domain)) {
    return (
      <div style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
        <div style={{ width: size, height: size, borderRadius: radius, background: bg, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img src={`https://www.google.com/s2/favicons?domain=${domain}&sz=128`} alt={name} onError={() => { _googleFailed.add(domain); setTick(t => t + 1) }} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        </div>
        {crBadge}
      </div>
    )
  }

  return (
    <div style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
      <div style={{ width: size, height: size, borderRadius: radius, background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: Math.round(size * 0.52) }}>
        {CAT_ICON(category)}
      </div>
      {crBadge}
    </div>
  )
}
